enum DisplayNames {
  Modal = 'Modal',
  ModalBody = 'ModalBody',
  ModalBodyCloseButton = 'ModalBodyCloseButton',
  ModalContent = 'ModalContent',
  ModalFooter = 'ModalFooter',
  ModalHeader = 'ModalHeader',
  ModalOverlay = 'ModalOverlay'
}

export default DisplayNames;
